module.exports = __webpack_public_path__ + "img/chevron-down.52686537.svg";